import { EditOutlined } from '@ant-design/icons';
import { Button, Flex, Tooltip, Typography } from 'antd';
import cn from 'classnames';
import { Link } from 'react-router-dom';

import {
  U_ACTION,
  U_BRANCH,
  U_KEY,
  U_NAME,
  U_QUANTITY,
  WAREHOUSES,
} from '@app/constants';
import type { WarehousesRegistryColumns } from '@app/pages/Warehouses/WarehouseRegistry/types';
import type { ModelWarehouse } from '@app/services/rtkQuery/Warehouses/types';
import { ArchiveLabel } from '@app/shared/components';
import type { NBranches } from '@app/types';

const { Text } = Typography;

export const adaptWareHousesToTable = (
  data: ModelWarehouse[],
  branches: NBranches.BranchesForSystem[],
  IsWarehouseEdit: boolean
): WarehousesRegistryColumns[] => {
  const branchesMap = new Map(
    branches.map((branch) => [branch.Id, branch.Name])
  );

  return data
    .slice()
    ?.sort((a, b) => {
      return a?.IsDeleted === b?.IsDeleted ? 0 : a?.IsDeleted ? 1 : -1;
    })
    ?.map((warehouse) => {
      const { Id, Name, Comment, BranchIds, CountProducts, IsDeleted } =
        warehouse;

      return {
        [U_KEY]: String(Id),
        [U_NAME]: (
          <div
            className={cn('WarehousesRegistry__name', {
              'half-opacity': IsDeleted,
            })}
          >
            <Link
              to={`/${WAREHOUSES}/edit/?id=${Id}`}
              className={cn('WarehousesRegistry__name-link', 'no-wrap-text')}
            >
              {Name}
            </Link>
            <br />
            {Comment && (
              <Text className="WarehousesRegistry__comment">{Comment}</Text>
            )}
            {IsDeleted && <ArchiveLabel />}
          </div>
        ),
        [U_BRANCH]: (
          <Flex
            vertical
            gap={6}
            className={cn('WarehousesRegistry__branches', 'no-wrap-text', {
              'half-opacity': IsDeleted,
            })}
          >
            {BranchIds?.length ? (
              BranchIds.map((id) => (
                <div key={id} className="WarehousesRegistry__branch-item">
                  {branchesMap.get(id) || '-'}
                </div>
              ))
            ) : (
              <div className="WarehousesRegistry__branch-item">-</div>
            )}
          </Flex>
        ),
        [U_QUANTITY]: (
          <span
            className={cn('WarehousesRegistry__quantity', {
              'half-opacity': IsDeleted,
            })}
          >
            {CountProducts}
          </span>
        ),
        [U_ACTION]: IsWarehouseEdit ? (
          <div className="WarehousesRegistry__action">
            <Tooltip title="Редактировать">
              <Link to={`/${WAREHOUSES}/edit/?id=${Id}`}>
                <Button icon={<EditOutlined />} />
              </Link>
            </Tooltip>
          </div>
        ) : null,
      };
    });
};
